<div class="row">
  <div class="col-md-6">
    <h3 class="title-page text-primary">Danh sách CBCC kiểm tra thực tế hàng hóa</h3>
  </div>
  <div class="col-md-6" style="text-align: right; margin-top: 15px;">
    <button style="margin-right: 5px;" type="button" class="btn btn-primary" data-toggle="modal" (click)="createNewContact()"
      data-target="#mdNewCbcc">
      Thêm mới
    </button>
    <button id="fakeUpdateButton" style="margin-right: 5px; display: none" type="button" class="btn btn-primary" data-toggle="modal"
      data-target="#mdNewCbcc">
    </button>
    <button style="margin-right: 5px;" (click)="deleteMulti()" [disabled]="isDeleteMulti"
      class="btn btn-primary">Xóa</button>
  </div>
</div>
<div style="float: right;">
  <pagination-controls id="paging" (pageChange)="onChangePage($event)" (pageBoundsCorrection)="onChangePage($event)"
    maxSize="20" directionLinks="true" responsive="true" previousLabel="Trước" nextLabel="Sau"
    screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page">
  </pagination-controls>
</div>
<table class="table table-bordered table-striped">
  <thead>
    <th scope="col" style="text-align: center;"> </th>
    <th scope="col" style="text-align: center;">STT</th>
    <th scope="col" style="text-align: center;">Họ và tên</th>
    <th scope="col" style="text-align: center;">Chức vụ</th>
    <th scope="col" style="text-align: center;">Số điện thoại</th>
    <th scope="col"></th>
  </thead>
  <tbody>
    <tr
      *ngFor="let contact of contacts | paginate: { id: 'paging', itemsPerPage: pageSize, currentPage: page, totalItems: count }; let i = index ">
      <td> <input checkOne type="checkbox" (change)="checkedItem()" [name]="contact.id" [id]="contact.id"
          [(ngModel)]="contact.checked"></td>
      <td style="text-align: center;">{{contact.stt}}</td>
      <td style="text-align: left;"><a (click)="viewDetails(contact.id)" class="nav-link">{{contact.name}}</a></td>
      <td>{{contact.position}}</td>
      <td>{{contact.phoneNumber}}</td>
      <td class="text-center"><a (click)="delete(contact.id, contact.name)"><i class="fa fa-trash-o"
            aria-hidden="true"></i></a> &nbsp;
        <a (click)="updateContact(contact)"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
      </td>
    </tr>
  </tbody>
</table>
<div style="float: right;">
  <pagination-controls id="paging" (pageChange)="onChangePage($event)" (pageBoundsCorrection)="onChangePage($event)"
    maxSize="20" directionLinks="true" responsive="true" previousLabel="Trước" nextLabel="Sau"
    screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page">
  </pagination-controls>
</div>
<!-- The Modal -->
<div class="modal" id="mdNewCbcc">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Tạo CBCC mới</h4>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label" for="name">Họ và tên</label>
          <input class="form-control" id="name" required [(ngModel)]="contactNew.name" name="verifyName" />
        </div>
        <div class="mb-3">
          <label class="form-label" for="position">Vị trí</label>
          <input class="form-control" id="position" required [(ngModel)]="contactNew.position" name="position" />
        </div>
        <div class="mb-3">
          <label class="form-label" for="phoneNumber">Số điện thoại</label>
          <input class="form-control" id="phoneNumber" required [(ngModel)]="contactNew.phoneNumber"
            name="phoneNumber" />
        </div>
        <div class="mb-3">
          <label class="form-label" for="stt">Số thứ tự</label>
          <input class="form-control" id="stt" required [(ngModel)]="contactNew.stt"
            name="stt" />
        </div>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="closeModal()" data-dismiss="modal">Đóng lại</button>
        <button type="button" class="btn btn-success" (click)="saveContact()" data-dismiss="modal">Lưu lại</button>
      </div>
    </div>
  </div>
</div>
